import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ProgramsSection from './components/ProgramsSection';
import STEAMSection from './components/STEAMSection';
import KitsSection from './components/KitsSection';
import VoucherSection from './components/VoucherSection';
import RegistrationForms from './components/RegistrationForms';
import TestimonialSection from './components/TestimonialSection';
import PartnershipSection from './components/PartnershipSection';
import GallerySection from './components/GallerySection';
import ConsultationSection from './components/ConsultationSection';
import Footer from './components/Footer';

export default function RoboticsRegisterPage() {
  const [searchParams] = useSearchParams();
  const [selectedCourseVoucher, setSelectedCourseVoucher] = useState('');
  const [selectedCarVoucher, setSelectedCarVoucher] = useState('');

  useEffect(() => {
    const voucher = searchParams.get('voucher');
    const type = searchParams.get('type');
    
    if (voucher && type) {
      if (type === 'course') {
        setSelectedCourseVoucher(voucher);
        setTimeout(() => {
          const formElement = document.getElementById('course-form');
          if (formElement) {
            formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 500);
      } else if (type === 'car') {
        setSelectedCarVoucher(voucher);
        setTimeout(() => {
          const formElement = document.getElementById('car-form');
          if (formElement) {
            formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 500);
      }
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <ProgramsSection />
      <STEAMSection />
      <KitsSection />
      <PartnershipSection />
      <GallerySection />
      <ConsultationSection />
      <VoucherSection 
        onCourseVoucherSelect={setSelectedCourseVoucher}
        onCarVoucherSelect={setSelectedCarVoucher}
      />
      <RegistrationForms 
        selectedCourseVoucher={selectedCourseVoucher}
        selectedCarVoucher={selectedCarVoucher}
      />
      <TestimonialSection />
      <Footer />
    </div>
  );
}